<template>
    <!-- 均值方差 -->
    <div class="adjustBox">
        <div class="search">
            <el-select v-model="searchType" class="select-one search-input" style="width: 150px;" placeholder="请选择类型">
                <el-option label="私募产品" value="私募产品"></el-option>
                <el-option label="比较基准" value="比较基准"></el-option>
                <el-option label="展恒指数" value="展恒指数"></el-option>
            </el-select>
            <el-input placeholder="请输入内容" class="search-input ml20" prefix-icon="el-icon-search" v-model="search"></el-input>
            <el-button type="normal" class="ml20" @click="serach">搜索</el-button>
        </div>
        <div class="mt30">
            <el-table class="table-two" :data="gridData" height="240" border>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column property="secuNameAbbr" label="产品名称" width="230">
                    <template slot-scope="scope">
                        <a v-if="searchType=='私募产品'" class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/product?code='+scope.row.innerCode" target="_blank">{{scope.row.secuNameAbbr}}</a>
                        <span v-else :title="scope.row.secuNameAbbr">{{scope.row.secuNameAbbr}}</span>
                    </template>
                </el-table-column>
                <el-table-column property="managerName" label="基金管理人"></el-table-column>
                <el-table-column property="createDate" label="成立日期"></el-table-column>
                <el-table-column property="newestDate" label="最新净值日期"></el-table-column>
                <el-table-column property="newestEquity" label="最新净值">
                    <template slot-scope="scope"><span>{{scope.row.newestEquity?parseFloat(scope.row.newestEquity).toFixed(4):'--'}}</span></template>
                </el-table-column>
                <el-table-column property="thisYearYield" label="今年以来收益">
                    <template slot-scope="scope">
                        <span v-if="scope.row.thisYearYield" :class="[{rColor:scope.row.thisYearYield>0},{gColor:scope.row.thisYearYield<0}]">{{parseFloat(scope.row.thisYearYield*100).toFixed(2)}}%</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column property="opera" label="操作" width="150">
                    <template slot-scope="scope">
                        <span class="mainColor" @click="addTrade(scope.row)">添加到交易标的</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="adjustBox-Subject mt10">
                <el-row class="row-two"><h3 class="title">交易标的</h3></el-row>
                <el-form v-show="regionList.length>0" :model="timeForm" class="form-one mt20" :inline="true" label-position="right">
                    <el-form-item label="选择时间：">
                        <el-radio-group v-model="timeForm.time" v-for="(item,i) in regionList" :key="i+'time'" class="radio-btnt" value-key="id" @change="timeChange">
                            <el-radio-button :label="item.region">{{item.region}}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <img src="@/assets/images/time.png" alt="">
                        <el-date-picker type="date" class="date-picker-two ml20" :editable="false" placeholder="选择日期" v-model="timeForm.startDate" :clearable="false" @change="timeForm.time=''" value-format="yyyy-MM-dd"></el-date-picker> -
                        <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="timeForm.endDate" :clearable="false" @change="timeForm.time=''" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                </el-form>
                <!-- 均值方差 -->
                <div class="side2 mt20">
                    <div v-loading="!jzfcShow" class="echarts">
                        <chart v-if="jzfcShow" class="echarts" id="jzfc1" :option="optionJzfc"></chart>
                    </div>
                    <div style="margin-left: 10px;">
                        <el-form :model="tradeForm" class="form-one" :inline="true" label-position="right">
                            <el-form-item label="目标波动率：">
                                <el-input v-model="tradeForm.bdl" class="dashed-line"><i slot="suffix" class="el-input__icon">%</i></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="bdSubmit">确认</el-button>
                            </el-form-item>
                        </el-form>
                        <el-table class="table-two" :data="varianceData" border  height="250">
                            <el-table-column type="index" width="50"></el-table-column>
                            <el-table-column property="secuNameAbbr" label="产品名称" width="230">
                                <template slot-scope="scope">
                                    <a v-if="searchType=='私募产品'" class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/product?code='+scope.row.innerCode" target="_blank">{{scope.row.secuNameAbbr}}</a>
                                    <span v-else :title="scope.row.secuNameAbbr">{{scope.row.secuNameAbbr}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column property="date" label="当期权重">
                                <template slot-scope="scope">
                                    <span>{{scope.row.dqCon}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column property="opera" label="操作" width="120">
                                <template slot-scope="scope">
                                    <span class="mainColor" @click="deleteTrade(scope.row)">删除</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import chart from "../../components/chart";

export default {
    name: "weightCalculation",
    components:{
        chart, 
    },
    data() {
        return {
            // 基金搜索
            search:'',
            gridData: [],
            // 均值方差
            optionJzfc: {
                title: {text: '收益率',left:5,textStyle:{color:'#5D5D5D',fontWeight:'normal',fontSize:12,} },
                visualMap: {
                    min: 0,
                    max: 0.2,
                    precision: 2,//数据展示的小数精度，默认为0，无小数点。
                    realtime: false,
                    itemWidth: 15,
                    itemHeight: 180,
                    align: 'left',
                    orient: 'vertical',
                    right: 0,
                    top: 'center',
                    calculable: true,
                    inRange: {
                        color: ['#f2c31a', '#24b7f2']
                    }
                },
                grid: {top:'15%',left: '0%',right: '15%',bottom: '10%',containLabel: true},
                tooltip: {
                    axisPointer: {
                        type: 'cross'
                    },
                    trigger: 'axis',
                    formatter: function (params) {
                        // console.log(params);
                        var htmlStr = '<div class="echarts-tooltip-one"><table>';
                        for (let i = 0; i < params.length; i++) {
                            htmlStr += '<tr><td><span class="color-block"' + '"></span>' + params[i].seriesName + '：</td><td>（' + (params[i].data[0] * 100).toFixed(2) + '%，'+(params[i].data[1] * 100).toFixed(2)+'%）</td></tr>';
                        }
                        htmlStr += '</table></div>';
                        return htmlStr;
                    }
                },
                xAxis: {
                    type: 'value',
                    name: '波动率',
                    min: function(value) {
                        return Number(value.min) - 0.02
                    },
                    nameTextStyle: {color:'#5D5D5D',fontSize:12,},
                    axisLine:{lineStyle:{color: "#DCDCDC"}},
                    axisLabel: {
                        formatter:function (val){return (val*100).toFixed(2)+'%'},
                        fontSize:12,color:'#70787F'
                    },
                    data: [],
                },
                yAxis: {
                    type: 'value',
                    axisLine:{lineStyle:{color: "#DCDCDC"}},
                    min: function(value) {
                        return Number(value.min) - 0.01
                    },
                    axisLabel: {
                        formatter:function (val){return (val*100).toFixed(2)+'%'},
                        fontSize:12,color:'#70787F'
                    },
                },
                series: [
                    {
                        name: '有效前沿',
                        type: 'line',
                        // showAllSymbol: true,//示折线图上所有小标签
                        showSymbol: false,
                        color: '#B81616',
                        lineStyle: { color: "#B81616" },
                        data:[],
                    },
                    {
                        name: '方差',
                        type: 'scatter',
                        symbolSize: 5,
                        silent: false,
                        data:[],
                    },
                ],
            },
            varianceData:[],
            innerCodes: [],
            tradeForm: {
                bdl: '',
            },
            searchType: '私募产品',
            jzfcShow: true,
            changeFlag: false,
            timeForm: {
                time: '',
                startDate: '',
                endDate: '',
            },
            regionList: []
        }
    },
    mounted() {
        
    },
    methods: {
        // 基金搜索
        getFundLists() {
            let vm = this
            vm.gridData = []
            vm.$http.post(vm.$apiPath.GetFundSeachResult, {
                KeyWords: vm.search.trim(), //模糊查询关键词
                Page: 1, //页码
                PageNum: 10 //每页条数
            }).then(res => {
                // console.log(res);
                if (res.data.code == "200") {
                    vm.gridData = res.data.data.dataList
                }
            }).catch(err => { })
        },
        addTrade(val) {
            // console.log(val);
            for(let i = 0; i < this.innerCodes.length; i++) {
                if(this.innerCodes[i] == val.innerCode) {
                    return;
                }
            }
            this.innerCodes.push(Number(val.innerCode))
            this.getFundsDatePhase()//时间
            this.varianceData.push({
                innerCode:val.innerCode,
                secuNameAbbr:val.secuNameAbbr,
                dqCon:'--',
                values: []
            })
            this.$message.success('添加成功')
            this.changeFlag = true
        },
        // 均值方差
        async getMeanVariance() {
            let vm = this
            await vm.$http.post(vm.$apiPath.GetMeanVariance, {
                InnerCodes:this.innerCodes,
            }).then(res => {
                // console.log(res);
                this.jzfcShow = true
                this.changeFlag = false
                if(res.data.code == 200 && res.data.data) {
                    let xdata = res.data.data
                    if(xdata.nameList.length > 0) {
                        vm.varianceData = []
                        xdata.nameList.forEach((item,i) => {
                            vm.varianceData.push({
                                secuNameAbbr: item,//产品名称
                                innerCode: xdata.fundList[i].name,
                                dqCon: '--',//当期权重 parseFloat(xdata.fundList[i].value[0]*100).toFixed(2)
                                values: xdata.fundList[i].value
                            })
                        })
                        // console.log('均值方差',vm.varianceData);
                        vm.optionJzfc.series[1].data = xdata.dotList
                        vm.optionJzfc.series[0].data = xdata.lineList 
                        vm.optionJzfc.visualMap.max = xdata.scopeList[0]
                        vm.optionJzfc.visualMap.min = xdata.scopeList[1]
                    } else {
                        this.$emit('getCode', '');
                    }
                } else {
                    this.$emit('getCode', '');
                    vm.optionJzfc.series[0].data = []
                    vm.optionJzfc.series[1].data = []
                }
            }).catch(err => { })
        },
        // 删除交易标的
        deleteTrade(val) {  
            const i1 = this.varianceData.findIndex(item => item.innerCode == val.innerCode)
            const i2 = this.innerCodes.findIndex(item => item == val.innerCode)
            this.varianceData.splice(i1, 1)
            this.innerCodes.splice(i2, 1)
            this.changeFlag = true
            this.getFundsDatePhase()
        },
        async bdSubmit() {
            let index = 0
            this.$emit('getCode', '');//解决页面修改数据不刷新问题
            if(this.changeFlag) {
                this.jzfcShow = false
                await this.getMeanVariance()
            }
            for(; index < this.optionJzfc.series[0].data.length - 1; index++) {
                let item = this.optionJzfc.series[0].data[index]
                if((item[0]*100).toFixed(2) <= Number(this.tradeForm.bdl)) {
                    break;
                }
            }
            this.varianceData.forEach((item,i) => {
                item.dqCon = parseFloat(item.values[index]*100).toFixed(2)
            })
            if(this.varianceData.length > 0) {
                this.addedTempPortfolioFund()//增加临时组合持有基金
            }
        },
        addedTempPortfolioFund() {
            let vm = this
            let fundList = new Array()
            vm.varianceData.forEach(item => {
                fundList.push({
                    InnerCode: item.innerCode,
                    Proportion: item.dqCon,
                })
            })
            vm.$http.post(vm.$apiPath.AddedTempPortfolioFund, {
                DealDate: vm.timeForm.startDate,
                FundList: fundList 
            }).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    vm.$emit('getCode', res.data.data.note);
                } else {
                    vm.$emit('getCode', '');
                    vm.$message.error(res.data.message)
                }
            })
        },
        getBaselineLists() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetCompareFuzzySeachResult, {
                innerType: vm.searchType, //内部类型
                KeyWords: vm.search.trim() //模糊查询关键词
            }).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let search = res.data.data.dataList;
                    search.forEach(item => {
                        item.managerName = '--'
                        item.createDate = '--'
                        item.newestDate = '--'
                        item.secuNameAbbr = item.secuName
                    })
                    vm.gridData = search
                }
            })
        },
        serach() {
            if(this.search != '') {
                if(this.searchType == '私募产品') {
                    this.getFundLists()
                } else {
                    this.getBaselineLists()
                }
            }
        },
        getFundsDatePhase() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetFundsDatePhase, {
                InnerCodes:this.innerCodes,
            }).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    vm.regionList = res.data.data.regionList
                    if(vm.regionList.length > 0) {
                        vm.timeForm = {
                            time: vm.regionList[0].region,
                            startDate: vm.regionList[0].startDate,
                            endDate: vm.regionList[0].endDate,
                        }
                    }
                }
            })
        },
        timeChange(val) {
            let active = this.regionList.find(item => {return item.region == val})
            this.timeForm.startDate = active.startDate
            this.timeForm.endDate = active.endDate
        },
    },
}
</script>

<style scoped lang="less">
.adjustBox {
    .search {
        display: flex;justify-content: center;align-items: center;
        &-input {
            width: 410px;
            /deep/.el-input__inner{height: 30px;line-height: 30px;border-color: @borderColor;}
            /deep/.el-input__icon{line-height: 30px;}
        }
    }
    .mainColor {cursor: pointer;}
    &-Subject {
        padding: 20px 15px 0;
        .side2 {display: flex;justify-content: center;}
        .echarts {width: 550px;height: 350px;}
    }
    /deep/.el-radio-button {margin-right: 20px;}
}
</style>